import React, {useEffect, useState} from 'react';
import Card from '@mui/material/Card';
import {catalogueActivityLogService} from '../../services/TaskPoolServices';
import Moment from 'react-moment';
import {Drawer} from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function ActivityLogs(props) {
  const {catalogId, openLog, handleLogClose} = props;
  const [task, setTask] = useState([]);

  useEffect(() => {
    getTaskPoolActivityLog();
  }, []);

  const getTaskPoolActivityLog = () => {
    catalogueActivityLogService('get', catalogId).then(res => {
      setTask(res?.data || []);
    })
  }

  return (
    <Drawer
      open={openLog}
      anchor="right"
      onClose={handleLogClose}
      BackdropProps={{style: {backgroundColor: 'rgba(0, 0, 0, 0)'}}}
      sx={{
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: '30%',
          height: 'calc(100% - 87px)',
          top: 87,
          backgroundColor: '#F4F7FC',
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #E5E7EB',
          background: '#fff',
        }}
      >
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 600,
            color: '#1E293B',
          }}
        >
          Audit Trail
        </Typography>
        <IconButton onClick={handleLogClose}>
          <CloseRoundedIcon/>
        </IconButton>
      </Box>

      <Box 
        sx={{
          p: 2,
          overflowY: 'auto',
          height: '100%',
        }}
      >
        {task && task.length > 0 ? (
          task?.map((val, index) => (
            <Card 
              key={index}
              elevation={2} 
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 3,
                borderLeft: '5px solid #616B88',
              }}
            >
              <Typography 
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#1F2937',
                  mb: 1,
                }}
              >
                {val?.message || <>Catalog {val?.state === 'forwarded_to_curator' ? 'forwarded to curator' : (val?.state === 'forwarded_to_admin' ? 'forwarded to admin' : val?.state)} by <strong>{val?.by_name}</strong></>}
              </Typography>

              <Box
                sx={{
                  display: 'inline-block',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: '20px',
                  backgroundColor: 
                    val?.state?.includes('admin') || val?.state === 'completed' 
                      ? '#E8F5E9' 
                      : '#E3F2FD',
                  color: 
                    val?.state?.includes('admin') || val?.state === 'completed' 
                      ? '#2E7D32' 
                      : '#1565C0',
                  fontSize: 13,
                  fontWeight: 600,
                  mb: 1.5,
                  textTransform: 'capitalize'
                }}
              >
                {val?.state_label || (val?.state === 'forwarded_to_curator' ? 'Curator' : (val?.state === 'forwarded_to_admin' ? 'Admin' : val?.state))}
              </Box>

              {val?.description && (
                <Typography 
                sx={{
                  fontSize: 14,
                  color: '#4B5563',
                  mb: 1.5,
                  lineHeight: 1.4
                }}
              >
                {val?.description}
              </Typography>
              )}

              <Typography 
                sx={{
                  fontSize: 13,
                  color: '#6B7280',
                }}
              >
                <Moment format="MMMM Do YYYY, h:mm:ss a">{val?.timestamp}</Moment>
              </Typography>
            </Card>
          ))
        ) : (
          <Box
            sx={{
              height: '80%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#9CA3AF',
                fontSize: 15,
              }}
            >
              No activity logs available
            </Typography>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}